/**
 * Menghapus satu benda dari pohon data, dan mengatakan apa lagi yang ikut.
 *
 * Penghapusan di aplikasi ini menurun: sebuah set kurva membawa kurvanya,
 * sebuah sumur membawa seluruh set, zona, marker dan runnya. Yang berbahaya
 * bukan penghapusannya melainkan diamnya — "Hapus INTERPRETASI?" tidak
 * mengatakan bahwa delapan kurva ikut, dan orang yang menekannya menyangka ia
 * membuang satu baris di pohon.
 *
 * Karena itu dialog ini menerima daftar apa yang ikut terhapus, dan
 * mencetaknya. Dan untuk yang paling berat — sebuah sumur — nama sumurnya
 * harus diketik ulang: satu tekanan tombol adalah harga yang terlalu murah
 * untuk 465 kurva.
 */
import { useState } from "react";

import { Button, Modal, Notice } from "./ui";

export function DeleteDialog({
  title,
  what,
  consequences,
  keeps,
  confirmWord,
  busy,
  onCancel,
  onConfirm,
}: {
  /** Judul jendela, mis. "Hapus set kurva". */
  title: string;
  /** Nama benda yang akan dihapus, dicetak tebal. */
  what: string;
  /** Apa saja yang ikut terhapus; kosong berarti tidak ada yang ikut. */
  consequences: string[];
  /**
   * Apa yang justru **tidak** ikut terhapus, ketika itu yang sedang ditebak.
   *
   * Sebuah model taksiran yang dibuang tidak membawa kurva yang sudah
   * ditaksirnya; sebuah daftar kosong di atas tidak mengatakan begitu, ia hanya
   * diam — dan yang menekan tombolnya mengisi diam itu dengan tebakannya
   * sendiri, lalu tidak menekannya.
   */
  keeps?: string;
  /**
   * Kata yang harus diketik ulang sebelum tombolnya hidup. Kosong berarti
   * cukup ditekan — yang benar untuk satu kurva, dan tidak untuk satu sumur.
   */
  confirmWord?: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const [typed, setTyped] = useState("");
  const ready = !confirmWord || typed.trim() === confirmWord;
  return (
    <Modal
      title={title}
      width={420}
      onClose={onCancel}
      footer={
        <>
          <Button onClick={onCancel}>Cancel</Button>
          <Button variant="danger" busy={busy} disabled={!ready} onClick={onConfirm}>
            Delete
          </Button>
        </>
      }
    >
      <span style={{ font: "400 12px var(--font-sans)", color: "var(--ink-2)", lineHeight: 1.6 }}>
        <b>{what}</b> akan dihapus.
      </span>
      {consequences.length > 0 && (
        <Notice tone="warn">
          Yang ikut terhapus: {consequences.join(", ")}. Penghapusan ini tidak bisa dibatalkan.
        </Notice>
      )}
      {keeps && <Notice tone="info">{keeps}</Notice>}
      {confirmWord && (
        <label style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <span style={{ font: "400 10.5px var(--font-sans)", color: "var(--ink-5)" }}>
            Ketik <b>{confirmWord}</b> untuk mengonfirmasi
          </span>
          <input
            value={typed}
            autoFocus
            onChange={(event) => setTyped(event.target.value)}
            style={{
              height: 28,
              padding: "0 9px",
              background: "var(--control)",
              border: "1px solid var(--border-control)",
              borderRadius: "var(--radius)",
              font: "500 11.5px var(--font-mono)",
              color: "var(--ink)",
              outline: "none",
            }}
          />
        </label>
      )}
    </Modal>
  );
}
